// extracted by mini-css-extract-plugin
export var actionButton = "_6j-1";
export var actionButtons = "_6j-2";
export var actions = "_6j-0";
export var aiUnread = "_6j-10";
export var alignCenter = "_6j-h";
export var backWrapper = "_6j-3";
export var cellContainer = "_6j-4";
export var checkboxContainer = "_6j-5";
export var contentContainer = "_6j-6";
export var contentHeader = "_6j-8";
export var conversationsTableWrapper = "_6j-s";
export var draftReplyBadgeContainer = "_6j-m";
export var dropdownItem = "_6j-b";
export var dropdownItemsContainer = "_6j-a";
export var dropdownTitle = "_6j-c";
export var errorIcon = "_6j-7";
export var filter = "_6j-d";
export var gray = "_6j-i";
export var headerActionButtons = "_6j-e";
export var headerCheckboxContainer = "_6j-f";
export var icon = "_6j-j";
export var menuContainer = "_6j-k";
export var noMoreTicketsIcon = "_6j-12";
export var noMoreTicketsSubText = "_6j-13";
export var oneLine = "_6j-l";
export var optionsButton = "_6j-n";
export var plus = "_6j-o";
export var portalButtonsWrapper = "_6j-g";
export var red = "_6j-p";
export var scrolledTop = "_6j-9";
export var search = "_6j-q";
export var selectedConversationsCount = "_6j-r";
export var spinner = "_6j-t";
export var strong = "_6j-u";
export var summaryCell = "_6j-v";
export var tableContainer = "_6j-11";
export var tagContainer = "_6j-w";
export var threeDots = "_6j-x";
export var twoLines = "_6j-y";
export var unread = "_6j-z";